import { useObservable } from '../foundation/shared/utils/observable.hook';
import { useWindow } from './window.hook';
import { WindowRenderer } from './window-renderers';

export const WindowProvider = () => {
  const { windows$, closeWindow } = useWindow();
  const windows = useObservable(() => windows$);

  if (!windows || windows.size === 0) return null;

  return (
    <>
      {Array.from(windows.entries()).map(([type, payload]) => {
        return (
          <WindowRenderer
            key={type}
            type={type}
            payload={payload}
            closeWindow={closeWindow}
          />
        );
      })}
    </>
  );
};
